<template>
  <div>
    <ErrorNotice v-if='read.hasError()' :error='read.getError()' />
    <ErrorNotice v-if='write.hasError()' :error='write.getError()' />

    <LoadingLayout :isLoading='read.isLoading()' class='mt-4'>
      <FormView :controller='formController' :fields='collection.getEditFormFields()' :showCancel='false' buttonLabel='Save Changes' class='mt-4' />
    </LoadingLayout>

    <ProgressAlert :isPresenting='write.isLoading()'>
      <template #title>
        Creating {{ collection.getSingleLabel() }}
      </template>
    </ProgressAlert>
  </div>
</template>

<script setup>

import { reactive } from 'vue';

import { usePayloadQuery, usePayloadAction } from '@/kernel/api';
import { getCollection } from '@/kernel/collections';

import { useFormController } from '@/kernel/controllers/form-controller';
import { useToastManager } from '@/kernel/managers/toast-manager';

import LoadingLayout from '@/components/layouts/loading-layout.vue';

import ErrorNotice from '@/components/notices/error-notice.vue';
import ProgressAlert from '@/components/alerts/progress-alert.vue';
import FormView from '@/components/views/form-view.vue';
import SuccessToast from '@/components/toasts/success-toast.vue';

import { pushRoute } from '@/router/index.js';

const props = defineProps({
  collection: String,
  id: String
});

const collection = getCollection(props.collection);

const toastManager = useToastManager();
const toastController = toastManager.registerToast('collection-create-form', SuccessToast);

const read = usePayloadAction('GET', collection.getApiObjectEndpoint(props.id));

const write = usePayloadAction('PATCH', collection.getApiObjectEndpoint(props.id));

const formController = useFormController({
  onSubmit: async () => {
    if (!formController.hasDelta()) {
      return;
    }

    const data = formController.getDelta();

    try {
      await write.doAction({body: data});

      formController.setData(await read.doAction());

      toastController.present({data: {title: `${collection.getSingleLabel()} updated successfully.`}});

      const redirect = collection.getRedirectAfterEdit(read.getData());

      if (redirect) {
        pushRoute({path: redirect});
      }
    } catch(e) {
      window.scroll({
        top: 0,
        behaviour: 'smooth'
      });
    }
  }
});

(async () => {
  const data = await read.doAction();
  formController.setData(data);
})();

</script>
